<template>
    <div class="kefu_v">
        <!-- 悬浮返回按钮，叠在 iframe 之上，右上角 -->
        <div class="kefu_back" @click="goBack">
            <img src="../../views/images/item/back.png" alt="">
        </div>
        <iframe :src="data.kefu_link"></iframe>
    </div>
</template>

<script>
    import Fetch from '../../utils/fetch'

    export default {
        name: "kefu",
        components: {},
        data() {
            return {
                data: {}
            };
        },
        created() {
            this.$parent.footer('user');
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/webconfig', { type: 'web' }).then(res => {
                    this.data = res.data;
                })
            },
            goBack() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.replace('/index');
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    .kefu_v {
        position: fixed;
        width: 100%;
        height: 100%;
        -webkit-overflow-scrolling: touch;
        overflow-y: scroll;

        iframe {
            padding-bottom: 55px;
            width: 100%;
            height: 100%;
        }
    }

    /* 悬浮返回按钮 —— 右上角 */
    .kefu_back {
        position: fixed;
        top: 10px;
        right: 10px;
        width: 36px;
        height: 36px;
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.45);
        border-radius: 50%;
        cursor: pointer;

        img {
            width: 18px;
            height: 18px;
            /* 如果原图是向左的箭头，放右边可水平翻转让它朝右 */
            transform: rotate(180deg);
        }
    }
</style>